"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconNameList = void 0;
// NOTE: This is a generated svg list file, nothing you do here matters
// To rebuild this file run 'yarn run generate-svgs'
exports.IconNameList = [
    "Land",
    "add",
    "admin-settings",
    "app-switcher",
    "atmospheric-pressure",
    "avalanche",
    "back",
    "backspace",
    "bbq",
    "bbq-bad",
    "bbq-good",
    "bbq-goodish",
    "bbq-ok",
    "boating",
    "boating-bad",
    "boating-good",
    "boating-ok",
    "buoy",
    "caution-circle",
    "check",
    "check-circle",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "chop-height",
    "christmas",
    "close",
    "close-caption",
    "clothing-layers",
    "cloud",
    "coastal",
    "cold-front",
    "collapse",
    "concrete-mixing",
    "conditions",
    "copy-content",
    "cross",
    "cross-circle",
    "current-location-off",
    "current-location-on",
    "cyclist",
    "cyclist-bad",
    "cyclist-good",
    "cyclist-ok",
    "dashboards-app",
    "default-view",
    "delete",
    "desktop",
    "desktop-view",
    "download",
    "drag-vertical",
    "email",
    "exclamation",
    "exclamation-circle",
    "expand",
    "facebook",
    "farming",
    "favourite-off",
    "favourited-on",
    "favourites-empty",
    "favourites-full",
    "feedback",
    "filter",
    "fire-danger",
    "fire-danger-extreme",
    "fire-danger-extreme-alt",
    "fire-danger-high",
    "fire-danger-low",
    "fire-danger-moderate",
    "fire-danger-none",
    "fire-danger-veryhigh",
    "fire-season",
    "flag",
    "forecast",
    "forecast-app",
    "forecast-short",
    "forecast-video",
    "framing",
    "freezing-level",
    "graph",
    "grid-view",
    "gust",
    "hazard",
    "hazard-rain",
    "hazard-snow",
    "hazard-thunderstorm",
    "hazard-wind",
    "hazard-wind-chill",
    "heat-alert",
    "help",
    "high-pressure",
    "hindcast-app",
    "home",
    "humidity",
    "info",
    "info-circle",
    "instagram",
    "kayaking-risk",
    "kayaking-risk-high",
    "kayaking-risk-low",
    "kayaking-risk-moderate",
    "key",
    "landscaping",
    "lifts",
    "lightning-strike",
    "link",
    "linkedin",
    "list-view",
    "loading",
    "location",
    "logout",
    "low-pressure",
    "lower-base",
    "maintenance",
    "map",
    "marine-recreation",
    "matariki",
    "maximum-temperature",
    "measure-distance",
    "menu",
    "metraweather-logo",
    "metservice-logo",
    "metservice-mark",
    "minimum-temperature",
    "missing-content",
    "mobile-view",
    "moon-first-quarter",
    "moon-full",
    "moon-last-quarter",
    "moon-new",
    "moonrise",
    "moonset",
    "more-vertical",
    "motorist",
    "motorist-bad",
    "motorist-good",
    "motorist-ok",
    "mountain",
    "new-tab",
    "news",
    "no-wifi",
    "notice",
    "notifications",
    "observation",
    "observation-station",
    "occluded-front",
    "ocean",
    "outlook",
    "paddleboarding-risk",
    "paddleboarding-risk-high",
    "paddleboarding-risk-low",
    "paddleboarding-risk-moderate",
    "painting",
    "park",
    "particle-tracker-app",
    "past-weather",
    "pause",
    "pause-circle",
    "pdf",
    "pin",
    "play",
    "pollen-risk",
    "pollen-risk-high",
    "pollen-risk-low",
    "pollen-risk-moderate",
    "precipitation",
    "precipitation-heavy",
    "precipitation-light",
    "precipitation-moderate",
    "precipitation-none",
    "precipitation-torrential",
    "print",
    "products",
    "public-transit",
    "public-transit-bad",
    "public-transit-good",
    "public-transit-ok",
    "question-mark",
    "radio",
    "rain",
    "rain-heavy",
    "rain-light",
    "rain-moderate",
    "rain-none",
    "rain-probability-1-mm",
    "rain-probability-10-mm",
    "rain-torrential",
    "refresh",
    "region",
    "remove",
    "rename",
    "right-panel-open",
    "road",
    "rugby",
    "rural",
    "sand-temperture",
    "search",
    "set-face",
    "settings",
    "ski-field",
    "smartphone",
    "snow",
    "snow-contour",
    "social-media",
    "soil-moisture",
    "soil-temperature",
    "solar-forecast",
    "special-notices",
    "station-error",
    "stationary-front",
    "subtract",
    "sun-and-moon",
    "sunrise",
    "sunset",
    "surf",
    "surf-bad",
    "surf-good",
    "surf-ok",
    "swell",
    "swimming",
    "swimming-bad",
    "swimming-good",
    "swimming-ok",
    "swimming-risk",
    "swimming-risk-high",
    "swimming-risk-low",
    "swimming-risk-moderate",
    "swipe-horizontal",
    "tablet",
    "tablet-view",
    "temperature",
    "tide",
    "timer",
    "track-advanced",
    "track-easiest",
    "track-easy",
    "track-expert",
    "track-intermediate",
    "track-length",
    "track-wheelchair",
    "traffic-camera",
    "trend-down",
    "trend-up",
    "twitter",
    "upper-base",
    "urban",
    "user",
    "uv-risk",
    "uv-risk-high",
    "uv-risk-low",
    "uv-risk-moderate",
    "visibility",
    "visibility-off",
    "warm-front",
    "washing",
    "water-level",
    "wave-height",
    "wave-period",
    "waves",
    "weather-news",
    "weatherscape-cloud-app",
    "webcam",
    "whats-on",
    "wind",
    "wind-burb-10kt",
    "wind-burb-15kt",
    "wind-burb-35kt",
    "wind-burb-5kt",
    "wind-burb-75kt",
    "wind-chill",
    "wind-east-fresh",
    "wind-east-gale",
    "wind-east-light",
    "wind-east-lightmoderate",
    "wind-east-strong",
    "wind-none",
    "wind-north-fresh",
    "wind-north-gale",
    "wind-north-light",
    "wind-north-moderate",
    "wind-north-strong",
    "wind-northeast-fresh",
    "wind-northeast-gale",
    "wind-northeast-light",
    "wind-northeast-moderate",
    "wind-northeast-strong",
    "wind-northwest-fresh",
    "wind-northwest-gale",
    "wind-northwest-light",
    "wind-northwest-moderate",
    "wind-northwest-strong",
    "wind-south-fresh",
    "wind-south-gale",
    "wind-south-light",
    "wind-south-moderate",
    "wind-south-strong",
    "wind-southeast-fresh",
    "wind-southeast-gale",
    "wind-southeast-light",
    "wind-southeast-moderate",
    "wind-southeast-strong",
    "wind-southwest-fresh",
    "wind-southwest-gale",
    "wind-southwest-light",
    "wind-southwest-moderate",
    "wind-southwest-strong",
    "wind-west-fresh",
    "wind-west-gale",
    "wind-west-light",
    "wind-west-moderate",
    "wind-west-strong",
    "working-at-height",
    "zoom-in",
    "zoom-out",
];
